import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
import { RestaurantFormData } from "@/types/restaurantForm";
import { useNeighborhoods } from "@/hooks/useNeighborhoods";

interface NeighborhoodFieldProps {
  form: UseFormReturn<RestaurantFormData>;
}

export const NeighborhoodField = ({ form }: NeighborhoodFieldProps) => {
  const { data: neighborhoods } = useNeighborhoods();

  return (
    <FormField
      control={form.control}
      name="neighborhood_id"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Neighborhood</FormLabel>
          <Select 
            onValueChange={(value) => field.onChange(parseInt(value))}
            value={field.value?.toString()}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select a neighborhood" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {neighborhoods?.map((neighborhood) => (
                <SelectItem 
                  key={neighborhood.id} 
                  value={neighborhood.id.toString()}
                >
                  {neighborhood.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};